import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import {
  ArrowLeft,
  ArrowRight,
  Check,
  CloudUpload,
  Loader2,
  SquarePen,
  Trash2,
  X,
  XIcon,
} from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../../../component/form/form-layout";
import LeftSidePopupLayout from "../../../../../component/popup/modal-layout";
import { GlobalContext } from "../../../../../context/Context";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import { Alert, Snackbar } from "@mui/material";
import Chip from "../../../../../component/ui/chip";
import XCloseIcon from "../../../../../component/icons/x-close";

const AddTask = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  agentData = {},
  projectKey = "",
  usersList = [],
  taskData = {},
}) => {
  const apiCall = useApiCall();

  useEffect(() => {
    console.log("Task Data", taskData);
    if (taskData?.task_id) {
      taskFormik.setFieldValue("name", taskData?.task_name);
      taskFormik.setFieldValue("priority", taskData?.priority);
      taskFormik.setFieldValue("status", taskData?.task_status);
      taskFormik.setFieldValue("deadline", taskData?.deadline);
      taskFormik.setFieldValue(
        "assignee",
        taskData?.assigned_users.map((user) => user.user_id)
      );
      taskFormik.setFieldValue("description", taskData?.task_description);

      setPendingUploadTask(taskData?.attachments);
    }
  }, []);

  const [logoType, setLogoType] = useState("url");
  const [imagePreview, setImagePreview] = useState(null);
  const [status, setStatus] = useState(1);
  const [navIndex, setNavIndex] = useState(0);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [editSubTaskIndex, setEditSubTaskIndex] = useState(null);

  const [tasks, setTasks] = useState([]);
  const [subTasks, setSubTasks] = useState([]);
  const [mainTask, setMainTask] = useState({});
  const [isDirect, setisDirect] = useState(false);

  const [pendingUploadsTask, setPendingUploadTask] = useState([]);
  const [isDraggingTask, setIsDraggingTask] = useState(false);

  const [pendingUploadsSubTask, setPendingUploadsSubTask] = useState([]);
  const [isDraggingSubTask, setIsDraggingSubTask] = useState(false);

  const assignedData = [
    {
      name: "ALex",
      id: 1,
    },
    {
      name: "Jhon",
      id: 2,
    },
    {
      name: "ERobot",
      id: 3,
    },
    {
      name: "Mart",
      id: 4,
    },
    {
      name: "Liza",
      id: 5,
    },
  ];

  const priority = [
    {
      name: "Low",
      value: "low",
    },
    {
      name: "Medium",
      value: "medium",
    },
    {
      name: "High",
      value: "high",
    },
  ];

  const tStatus = [
    { name: "Pending", value: "pending" },
    { name: "In Process", value: "in_process" },
    { name: "Completed", value: "completed" },
    { name: "Cancelled", value: "cancelled" },
    // { name: "Incomplete Details", value: "incomplete_details" },
    // { name: "QA", value: "qa" },
    // { name: "QA Design", value: "qa_design" },
    // { name: "Delivered To Sales", value: "delivered_to_sales" },
    // { name: "File Sent To Client", value: "file_sent_to_client" },
    // { name: "Revision", value: "revision" },
    // { name: "Design", value: "design" },
    // { name: "Linked-In", value: "linked_in" },
    // { name: "Job Posting", value: "job_posting" },
    // { name: "On-Hold", value: "on_hold" },
    // { name: "Unassigned", value: "unassigned" },
    // { name: "Editing / Formatting", value: "editing_formatting" },
    // { name: "Client Approval", value: "client_approval" },
    // { name: "In-Active", value: "in_active" },
    // { name: "Final Drafts", value: "final_drafts" },
  ];
  const statusOptions = tStatus?.map((tm) => ({
    value: tm?.value,
    label: tm?.name,
  }));

  const userOptions = usersList?.map((s) => ({
    value: s.userid,
    label: s.name,
  }));

  const assignedOptions = assignedData?.map((tm) => ({
    value: tm?.id,
    label: tm?.name,
  }));
  const priorityOptions = priority?.map((tm) => ({
    value: tm?.value,
    label: tm?.name,
  }));
  // const validationSchema = yup.object({
  //   name: yup
  //     .string("This Field is Required")
  //     .required("This Field is Required"),
  //   priority: yup
  //     .string("This Field is Required")
  //     .required("This Field is Required"),
  //   deadline: yup
  //     .string("This Field is Required")
  //     .required("This Field is Required"),
  //   assignee: yup
  //     .array()
  //     .of(yup.string())
  //     .min(1, "This Field is Required")
  //     .required("This Field is Required"),
  // });

  const removeImage = () => {
    setImagePreview(null);
    taskFormik.setFieldValue("media", "");
  };

  const removeImageSubtask = () => {
    // setImagePreview(null);
    subTaskFormik.setFieldValue("media", "");
    subTaskFormik.setFieldValue("subTaskPreview", "");
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const taskValidation = yup.object({
    name: yup.string().required("This Field is Required"),
    priority: yup.string().required("This Field is Required"),
    status: yup.string().required("This Field is Required"),
    deadline: yup.string().required("This Field is Required"),
    assignee: yup
      .array()
      .min(1, "This Field is Required")
      .required("This Field is Required"),
  });

  const subTaskValidation = yup.object({
    sub_task_name: yup.string().required("This Field is Required"),
    priority: yup.string().required("This Field is Required"),
    deadline: yup.string().required("This Field is Required"),
    assignee: yup
      .array()
      .min(1, "This Field is Required")
      .required("This Field is Required"),
  });

  const taskFormik = useFormik({
    initialValues: {
      name: "",
      priority: "",
      status: "",
      deadline: "",
      assignee: [],
      description: "",
      media: "",
    },
    validationSchema: taskValidation,
    onSubmit: (values) => {
      console.log("va", values);
      setTasks((prev) => [...prev, { ...values, status }]);
      setMainTask(values);

      console.log(values);
      if (isDirect) {
        handleApply(values);
      }

      setisDirect(false);
    },
  });

  const subTaskFormik = useFormik({
    initialValues: {
      sub_task_name: "",
      priority: "",
      deadline: "",
      sub_task_status: "",
      assignee: [],
      sub_task_description: "",
      media: "",
      is_qa: 1,
      source: "logo",
    },
    validationSchema: subTaskValidation,
    onSubmit: (values) => {
      if (editSubTaskIndex !== null) {
        const ids = pendingUploadsSubTask?.map((item) => item.id) || [];
        const finalData = {
          ...values,
          attachment_ids: ids,
          media: pendingUploadsSubTask,
        };

        setSubTasks((prev) => {
          const updated = [...prev];
          updated[editSubTaskIndex] = finalData;
          return updated;
        });

        setEditSubTaskIndex(null); // reset edit mode
      } else {
        // ADD MODE → push new task
        console.log("sub task values", values);
        const ids = pendingUploadsSubTask?.map((item) => item.id) || [];
        const finalData = {
          ...values,
          attachment_ids: ids,
          media: pendingUploadsSubTask,
        };
        setSubTasks((prev) => [...prev, finalData]);
        console.log("sub task Final Data", finalData);
      }

      subTaskFormik.resetForm();
      setNavIndex(0);
      setPendingUploadsSubTask([]);
    },
  });

  const removeTask = (index) => {
    setTasks((prev) => prev.filter((_, i) => i !== index));
  };

  const removeSubTask = (index) => {
    setSubTasks((prev) => prev.filter((_, i) => i !== index));
    subTaskFormik.resetForm();
  };

  const editSubTask = (index) => {
    const item = subTasks[index];
    setEditSubTaskIndex(index);

    console.log("Sub item", item);

    subTaskFormik.setFieldValue("sub_task_name", item?.sub_task_name);
    subTaskFormik.setFieldValue("priority", item?.priority);
    subTaskFormik.setFieldValue("deadline", item?.deadline);
    subTaskFormik.setFieldValue("sub_task_status", item?.sub_task_status);
    subTaskFormik.setFieldValue("assignee", item?.assignee);
    subTaskFormik.setFieldValue(
      "sub_task_description",
      item?.sub_task_description
    );
    subTaskFormik.setFieldValue("media", item?.media);
    subTaskFormik.setFieldValue("subTaskPreview", item?.subTaskPreview);
    setPendingUploadsSubTask(item?.media);

    setNavIndex(1);
  };

  const handleApply = async (taskValues) => {
    const ids = pendingUploadsTask?.map((item) => item.id) || [];

    let data;

    !isDirect
      ? (data = {
          project_key: projectKey,
          task_name: mainTask?.name,
          task_description: mainTask?.description,
          task_status: mainTask?.status,
          is_qa: 1,
          deadline: mainTask?.deadline,
          priority: mainTask?.priority,
          source: "logo",
          assigned_users: mainTask?.assignee,
          sub_tasks: subTasks,
          attachment_ids: ids,
        })
      : (data = {
          project_key: projectKey,
          task_name: taskValues?.name,
          task_description: taskValues?.description,
          task_status: taskValues?.status,
          is_qa: 1,
          deadline: taskValues?.deadline,
          priority: taskValues?.priority,
          source: "logo",
          assigned_users: taskValues?.assignee,
          attachment_ids: ids,
        });

    if (!taskData?.task_id) {
      data.sub_tasks = subTasks;
    }

    console.log("DAta", data);

    try {
      const res = await apiCall({
        method: "post",
        url: taskData?.task_id
          ? `tasks/update-task/${taskData.task_id}`
          : "tasks/add-task",
        data,
      });
      console.log("API response:", res);
      onSubmit(res?.message || `Request Submitted`);
      onClose();
      setSubTasks([]);
      taskFormik.resetForm();
    } catch (error) {
      console.log(error);
      onError(
        error?.response?.data?.respMsg ||
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Some Thing Went Wrong"
      );
    }
  };

  const handleUploadImage = (image) => {
    const file = image;
    if (file) {
      taskFormik.setFieldValue("media", file);

      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
      console.log("Image Preview", imagePreview);
    }
  };

  const handleUploadImageSubTask = (image) => {
    const file = image;
    if (file) {
      subTaskFormik.setFieldValue("media", file);

      const previewUrl = URL.createObjectURL(file);
      subTaskFormik?.setFieldValue("subTaskPreview", previewUrl);
      console.log("Image Preview", previewUrl);
    }
  };

  const isTaskReady =
    taskFormik.values.name &&
    taskFormik.values.priority &&
    taskFormik.values.status &&
    taskFormik.values.deadline &&
    taskFormik.values?.assignee?.length > 0
      ? true
      : false;

  const isSubTaskReady =
    subTaskFormik.values.sub_task_name &&
    subTaskFormik.values.priority &&
    subTaskFormik.values.deadline &&
    subTaskFormik.values?.assignee?.length > 0;

  const handleTaskFileChange = async (e) => {
    const newFiles = Array.from(e.target.files);
    if (!newFiles?.length) return;

    const formData = new FormData();
    newFiles.forEach((f) => formData.append("files[]", f));

    try {
      const uploadRes = await apiCall({
        method: "post",
        url: "attachments/upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes?.data?.length) {
        setPendingUploadTask((prev) => [...uploadRes.data, ...prev]);
      }
    } catch (err) {
      console.error("Upload error:", err);
    } finally {
      e.target.value = ""; // reset file input
    }
  };

  // Handle drag & drop upload
  const handleTaskDragOver = (e) => {
    e.preventDefault();
    setIsDraggingTask(true);
  };
  const handleTaskDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingTask(false);
  };
  const handleTaskDrop = async (e) => {
    e.preventDefault();
    setIsDraggingTask(false);

    const droppedFiles = Array.from(e.dataTransfer.files);
    if (!droppedFiles?.length) return;

    const formData = new FormData();
    droppedFiles.forEach((f) => formData.append("files[]", f));

    try {
      const uploadRes = await apiCall({
        method: "post",
        url: "attachments/upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes?.data?.length) {
        setPendingUploadTask((prev) => [...uploadRes.data, ...prev]);
      }
    } catch (err) {
      console.error("Upload error:", err);
    }
  };

  // Delete pending unconfirmed upload
  const removePendingUploadTask = async (id) => {
    try {
      await apiCall({
        method: "post",
        url: taskData?.task_id
          ? `attachments/delete/${id}`
          : `attachments/delete-unconfirmed-attachment/${id}`,
      });
      setPendingUploadTask((prev) => prev.filter((p) => p.id !== id));
    } catch (err) {
      console.error("Failed to delete unconfirmed file:", err);
    }
  };

  /// SUb task Attactments Uploads

  const handleSubTaskFileChange = async (e) => {
    const newFiles = Array.from(e.target.files);
    if (!newFiles.length) return;

    const formData = new FormData();
    newFiles.forEach((f) => formData.append("files[]", f));

    try {
      const uploadRes = await apiCall({
        method: "post",
        url: "attachments/upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes?.data?.length) {
        setPendingUploadsSubTask((prev) => [...uploadRes.data, ...prev]);
      }
    } catch (err) {
      console.error("Upload error:", err);
    } finally {
      e.target.value = ""; // reset file input
    }
  };

  // Handle drag & drop upload
  const handleSubTaskDragOver = (e) => {
    e.preventDefault();
    setIsDraggingSubTask(true);
  };
  const handleSubTaskDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingSubTask(false);
  };
  const handleSubTaskDrop = async (e) => {
    e.preventDefault();
    setIsDraggingSubTask(false);

    const droppedFiles = Array.from(e.dataTransfer.files);
    if (!droppedFiles?.length) return;

    const formData = new FormData();
    droppedFiles.forEach((f) => formData.append("files[]", f));

    try {
      const uploadRes = await apiCall({
        method: "post",
        url: "attachments/upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes?.data?.length) {
        setPendingUploadsSubTask((prev) => [...uploadRes.data, ...prev]);
      }
    } catch (err) {
      console.error("Upload error:", err);
    }
  };

  // Delete pending unconfirmed upload
  const removePendingUploadSubTask = async (id) => {
    try {
      await apiCall({
        method: "post",
        url: `attachments/delete-unconfirmed-attachment/${id}`,
      });
      setPendingUploadsSubTask((prev) => prev.filter((p) => p.id !== id));
    } catch (err) {
      console.error("Failed to delete unconfirmed file:", err);
    }
  };

  return (
    <>
      <LeftSidePopupLayout
        popupStatus={true}
        className={Style.departmentChangeModal}
      >
        <div
          className={`${Style.modal_header} ${Style.addMeModal_head} flex justify-between items-center`}
        >
          <h4>{taskData?.task_id ? "Update" : "Add"} Task</h4>
          <div
            onClick={onClose}
            className={`${Style.close_btn} cursor-pointer`}
          >
            <XCloseIcon />
          </div>
        </div>

        {navIndex == 0 && (
          <div style={{ height: "100%", overflow: "auto" }}>
            <form
              onSubmit={taskFormik.handleSubmit}
              className={Style.modal_main}
            >
              <div className={Style.modal_body}>
                <div className={`${Style.dcmb__card}`}>
                  <div className={`${Style.dcmb__cardBody}`}>
                    <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                      <FormArea>
                        {/* Name */}
                        <FeildWraper width="100%">
                          <FormLabel required>Name</FormLabel>
                          <input
                            type="text"
                            name="name"
                            value={taskFormik.values.name}
                            onChange={taskFormik.handleChange}
                            placeholder="name"
                          />
                          {taskFormik.touched.name &&
                            taskFormik.errors.name && (
                              <FeildError>{taskFormik.errors.name}</FeildError>
                            )}
                        </FeildWraper>

                        {/* Assignee */}
                        <FeildWraper>
                          <FormLabel required>Assigned</FormLabel>

                          <Select
                            name="assignee"
                            className="text-sm"
                            classNamePrefix="react-select"
                            options={userOptions}
                            isMulti
                            components={{
                              IndicatorSeparator: () => null,
                              LoadingIndicator: () => null,
                            }}
                            value={userOptions?.filter((option) =>
                              Array.isArray(taskFormik.values.assignee)
                                ? taskFormik.values.assignee.includes(
                                    option.value
                                  )
                                : false
                            )}
                            filterOption={(option, inputValue) =>
                              option.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                            onChange={(selectedOptions) => {
                              const ids = selectedOptions?.map(
                                (opt) => opt.value
                              );
                              taskFormik.setFieldValue("assignee", ids);
                            }}
                            placeholder="Search or select..."
                            isClearable
                            menuPlacement="auto"
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                minHeight: "35px",
                                height: "auto",
                                borderRadius: "5px",
                                border: "1px solid #DFDFDF",
                                backgroundColor: state.isDisabled
                                  ? "#f0f0f0"
                                  : "#FFF",
                                boxShadow: state.isFocused ? "none" : "none",
                                "&:hover": { borderColor: "#DFDFDF" },
                                fontSize: "13px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: "#1E1E1E",
                                padding: "0 14px",
                                cursor: state.isDisabled
                                  ? "not-allowed"
                                  : "normal",
                                margin: 0,
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                height: "auto",
                                padding: 0,
                                margin: 0,
                                flexWrap: "wrap",
                                gap: "2px",
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: "#E5E7EB",
                                borderRadius: "3px",
                                padding: "2px 6px",
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                margin: 0,
                                padding: 0,
                                fontSize: "13px",
                                fontWeight: 500,
                                color: "#1E1E1E",
                                height: "auto",
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: "#666",
                                ":hover": {
                                  backgroundColor: "#D1D5DB",
                                  color: "#000",
                                },
                              }),
                              option: (base, state) => ({
                                ...base,
                                fontSize: "14px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: state.isSelected ? "#FFF" : "#1E1E1E",
                                backgroundColor: state.isSelected
                                  ? "#3b82f6"
                                  : state.isFocused
                                  ? "#F3F4F6"
                                  : "#FFF",
                                padding: "8px 14px",
                                cursor: "pointer",
                              }),
                            }}
                          />
                          {taskFormik.touched.assignee &&
                            taskFormik.errors.assignee && (
                              <FeildError>
                                {taskFormik.errors.assignee}
                              </FeildError>
                            )}
                        </FeildWraper>

                        {/* Priority */}
                        <FeildWraper>
                          <FormLabel required>Priority</FormLabel>
                          <Select
                            name="priority"
                            className="text-sm"
                            classNamePrefix="react-select"
                            options={priorityOptions}
                            components={{
                              IndicatorSeparator: () => null,
                              LoadingIndicator: () => null,
                            }}
                            value={priorityOptions?.find(
                              (option) =>
                                option.value === taskFormik.values.priority
                            )}
                            onChange={(selectedOption) => {
                              taskFormik.setFieldValue(
                                "priority",
                                selectedOption?.value || ""
                              );
                            }}
                            filterOption={(option, inputValue) =>
                              option.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                            placeholder="Search or select..."
                            isClearable
                            menuPlacement="auto"
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                minHeight: "35px",
                                height: "auto",
                                borderRadius: "5px",
                                border: "1px solid #DFDFDF",
                                backgroundColor: state.isDisabled
                                  ? "#f0f0f0"
                                  : "#FFF",
                                boxShadow: state.isFocused ? "none" : "none",
                                "&:hover": { borderColor: "#DFDFDF" },
                                fontSize: "13px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: "#1E1E1E",
                                padding: "0 14px",
                                cursor: state.isDisabled
                                  ? "not-allowed"
                                  : "normal", // cursor change
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                height: "auto",
                                padding: "0 0px 0",
                              }),
                              input: (base) => ({
                                ...base,
                                margin: 0,
                                padding: 0,
                                fontSize: "14px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: "#1E1E1E",
                                height: "auto",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                fontSize: "14px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: "#1E1E1E",
                              }),
                              placeholder: (base) => ({
                                ...base,
                                fontSize: "14px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: "#717680",
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 99999,
                              }),
                              menu: (base) => ({
                                ...base,
                                marginTop: "2px",
                                borderRadius: "5px",
                                border: "1px solid #DFDFDF",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                              }),
                              option: (base, state) => ({
                                ...base,
                                fontSize: "14px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: state.isSelected ? "#FFF" : "#1E1E1E",
                                backgroundColor: state.isSelected
                                  ? "#3b82f6"
                                  : state.isFocused
                                  ? "#F3F4F6"
                                  : "#FFF",
                                padding: "8px 14px",
                                cursor: "pointer",
                              }),
                              indicatorContainer: (base) => ({
                                ...base,
                                padding: 0,
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                padding: 0,
                              }),
                            }}
                          />
                          {taskFormik.touched.priority &&
                            taskFormik.errors.priority && (
                              <FeildError>
                                {taskFormik.errors.priority}
                              </FeildError>
                            )}
                        </FeildWraper>

                        {/* Deadline */}

                        <FeildWraper>
                          <FormLabel required>Deadline</FormLabel>
                          <input
                            type="date"
                            name="deadline"
                            value={taskFormik.values.deadline}
                            onChange={taskFormik.handleChange}
                          />
                          {taskFormik.touched.deadline &&
                            taskFormik.errors.deadline && (
                              <FeildError>
                                {taskFormik.errors.deadline}
                              </FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                          <FormLabel required>Status</FormLabel>
                          <Select
                            name="status"
                            className="text-sm"
                            classNamePrefix="react-select"
                            options={statusOptions}
                            components={{
                              IndicatorSeparator: () => null,
                              LoadingIndicator: () => null,
                            }}
                            value={statusOptions?.find(
                              (option) =>
                                option.value === taskFormik.values.status
                            )}
                            onChange={(selectedOption) => {
                              taskFormik.setFieldValue(
                                "status",
                                selectedOption?.value || ""
                              );
                            }}
                            filterOption={(option, inputValue) =>
                              option.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                            placeholder="Search or select Status..."
                            isClearable
                            menuPlacement="auto"
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                minHeight: "35px",
                                height: "auto",
                                borderRadius: "5px",
                                border: "1px solid #DFDFDF",
                                backgroundColor: state.isDisabled
                                  ? "#f0f0f0"
                                  : "#FFF",
                                boxShadow: state.isFocused ? "none" : "none",
                                "&:hover": { borderColor: "#DFDFDF" },
                                fontSize: "13px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: "#1E1E1E",
                                padding: "0 14px",
                                cursor: state.isDisabled
                                  ? "not-allowed"
                                  : "normal", // cursor change
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                height: "auto",
                                padding: "0 0px 0",
                              }),
                              input: (base) => ({
                                ...base,
                                margin: 0,
                                padding: 0,
                                fontSize: "14px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: "#1E1E1E",
                                height: "auto",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                fontSize: "14px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: "#1E1E1E",
                              }),
                              placeholder: (base) => ({
                                ...base,
                                fontSize: "14px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: "#717680",
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 99999,
                              }),
                              menu: (base) => ({
                                ...base,
                                marginTop: "2px",
                                borderRadius: "5px",
                                border: "1px solid #DFDFDF",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                              }),
                              option: (base, state) => ({
                                ...base,
                                fontSize: "14px",
                                lineHeight: "1.2",
                                fontWeight: 500,
                                color: state.isSelected ? "#FFF" : "#1E1E1E",
                                backgroundColor: state.isSelected
                                  ? "#3b82f6"
                                  : state.isFocused
                                  ? "#F3F4F6"
                                  : "#FFF",
                                padding: "8px 14px",
                                cursor: "pointer",
                              }),
                              indicatorContainer: (base) => ({
                                ...base,
                                padding: 0,
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                padding: 0,
                              }),
                            }}
                          />
                          {taskFormik.touched.status &&
                            taskFormik.errors.status && (
                              <FeildError>
                                {taskFormik.errors.status}
                              </FeildError>
                            )}
                        </FeildWraper>

                        {/* Description */}
                        <FeildWraper width="100%">
                          <FormLabel>Description</FormLabel>
                          <textarea
                            name="description"
                            value={taskFormik.values.description}
                            onChange={taskFormik.handleChange}
                            rows={6}
                            placeholder="Write  description here..."
                          />
                        </FeildWraper>

                        {/* File Upload */}

                        <FeildWraper width="100%">
                          {/* Upload Box */}
                          <div
                            onClick={() =>
                              document.getElementById("fileInput").click()
                            }
                            onDragOver={handleTaskDragOver}
                            onDragLeave={handleTaskDragLeave}
                            onDrop={handleTaskDrop}
                            className={`border-2 border-dashed rounded-xl p-6 flex flex-col items-center justify-center text-center transition cursor-pointer ${
                              isDraggingTask
                                ? "border-black bg-gray-100"
                                : "border-gray-300 bg-gray-50 hover:bg-gray-100"
                            }`}
                          >
                            <CloudUpload className="w-10 h-10 text-black mb-3" />
                            <p className="text-gray-700 text-sm mb-2">
                              Drag & drop files here or click to select
                            </p>

                            <input
                              type="file"
                              multiple
                              onChange={handleTaskFileChange}
                              className="hidden"
                              id="fileInput"
                            />

                            {/* Pending uploads */}
                            {pendingUploadsTask?.length > 0 && (
                              <div className="mt-4 w-full max-w-sm">
                                <div className="text-xs text-gray-700 mb-2 font-semibold">
                                  Pending uploads
                                </div>
                                <ul className="text-xs text-gray-700 text-left space-y-2">
                                  {pendingUploadsTask?.map((p) => (
                                    <li
                                      key={p.id}
                                      className="flex items-center justify-between bg-gray-100 px-3 py-2 rounded-md"
                                    >
                                      <span className="truncate max-w-[150px]">
                                        {p.file_name}
                                      </span>
                                      <button
                                        type="button"
                                        onClick={async (e) => {
                                          e.stopPropagation();
                                          await removePendingUploadTask(p.id);
                                        }}
                                        className="text-gray-500 hover:text-red-600 transition"
                                        title="Remove pending upload"
                                      >
                                        <X className="w-4 h-4" />
                                      </button>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        </FeildWraper>
                      </FormArea>
                    </div>
                  </div>
                </div>

                {subTasks?.length > 0 && (
                  <div className="w-full rounded-xl border border-gray-200 bg-white shadow-sm">
                    {/* Table Header */}
                    <div className="grid grid-cols-5 gap-4 bg-gray-100 p-3 font-semibold text-gray-700 text-sm">
                      <span>Subtask Name</span>
                      <span>Status</span>
                      <span>Deadline</span>
                      <span>Assignees</span>
                      <span>Action</span>
                    </div>

                    {/* Table Rows */}
                    <div className="divide-y divide-gray-200">
                      {subTasks.map((s, i) => (
                        <div
                          key={i}
                          className="grid grid-cols-5 gap-4 items-center p-3 hover:bg-gray-50 transition-all text-sm text-gray-700"
                        >
                          {/* Subtask Name */}
                          <span className="font-medium">{s.sub_task_name}</span>

                          {/* Status */}
                          <span>
                            {s.sub_task_status ? (
                              <Chip color={s.statusColor || "blue"}>
                                {s.sub_task_status}
                              </Chip>
                            ) : (
                              "-"
                            )}
                          </span>

                          {/* Deadline */}
                          <span>
                            {s.deadline
                              ? new Date(s.deadline).toLocaleDateString()
                              : "-"}
                          </span>

                          {/* Assignees */}
                          <span className="flex -space-x-2">
                            {s?.assignee?.map((assigneeId, idx) => {
                              const user = usersList?.find(
                                (u) => u.userid === assigneeId
                              );
                              if (!user) return null;
                              const initials = user.name
                                .split(" ")
                                .map((n) => n[0])
                                .slice(0, 2)
                                .join("")
                                .toUpperCase();
                              return (
                                <div
                                  key={idx}
                                  className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center 
                 text-xs font-semibold shadow-sm border-2 border-white"
                                >
                                  {initials}
                                </div>
                              );
                            })}
                          </span>

                          {/* Delete Button */}
                          <span>
                            <button
                              type="button"
                              onClick={() => removeSubTask(i)}
                              className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50 transition-all"
                            >
                              <Trash2 size={16} />
                            </button>
                            <button
                              type="button"
                              onClick={() => editSubTask(i)}
                              className="text-blue-600 hover:text-blue-700 p-1 rounded hover:bg-red-50 transition-all"
                            >
                              <SquarePen size={16} />
                            </button>
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        )}
        {navIndex == 1 && !taskData?.task_id && (
          <LeftSidePopupLayout
            popupStatus={true}
            className="!w-[600px] max-w-[90vw] !m-auto  !bg-white  !h-[550px] !max-h-[90vh] !p-5 flex flex-col gap-4"
          >
            <div
              className={`${Style.modal_header} ${Style.addMeModal_head} flex justify-between items-center`}
            >
              <h4>Add Sub Task </h4>
              <div
                onClick={() => setNavIndex(0)}
                className={`${Style.close_btn} cursor-pointer`}
              >
                <XCloseIcon />
              </div>
            </div>
            <div style={{ height: "100%", overflow: "auto" }}>
              <form
                onSubmit={subTaskFormik.handleSubmit}
                className={Style.modal_main}
              >
                <div className={Style.modal_body}>
                  <FormArea>
                    {/* Name */}
                    <FeildWraper width="100%">
                      <FormLabel required>Name</FormLabel>
                      <input
                        type="text"
                        name="sub_task_name"
                        value={subTaskFormik.values.sub_task_name}
                        onChange={subTaskFormik.handleChange}
                        placeholder="name"
                      />
                      {subTaskFormik.touched.sub_task_name &&
                        subTaskFormik.errors.sub_task_name && (
                          <FeildError>
                            {subTaskFormik.errors.sub_task_name}
                          </FeildError>
                        )}
                    </FeildWraper>

                    <FeildWraper>
                      <FormLabel required>Assigned</FormLabel>

                      <Select
                        name="assignee"
                        className="text-sm"
                        classNamePrefix="react-select"
                        options={userOptions}
                        isMulti
                        components={{
                          IndicatorSeparator: () => null,
                          LoadingIndicator: () => null,
                        }}
                        value={userOptions?.filter((option) =>
                          Array.isArray(subTaskFormik.values.assignee)
                            ? subTaskFormik.values.assignee.includes(
                                option.value
                              )
                            : false
                        )}
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                        onChange={(selectedOptions) => {
                          const ids = selectedOptions?.map((opt) => opt.value);
                          subTaskFormik.setFieldValue("assignee", ids);
                        }}
                        placeholder="Search or select..."
                        isClearable
                        menuPlacement="auto"
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: "35px",
                            height: "auto",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            backgroundColor: state.isDisabled
                              ? "#f0f0f0"
                              : "#FFF",
                            boxShadow: state.isFocused ? "none" : "none",
                            "&:hover": { borderColor: "#DFDFDF" },
                            fontSize: "13px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            padding: "0 14px",
                            cursor: state.isDisabled ? "not-allowed" : "normal",
                            margin: 0,
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: "auto",
                            padding: 0,
                            margin: 0,
                            flexWrap: "wrap",
                            gap: "2px",
                          }),
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: "#E5E7EB",
                            borderRadius: "3px",
                            padding: "2px 6px",
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            margin: 0,
                            padding: 0,
                            fontSize: "13px",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            height: "auto",
                          }),
                          multiValueRemove: (base) => ({
                            ...base,
                            color: "#666",
                            ":hover": {
                              backgroundColor: "#D1D5DB",
                              color: "#000",
                            },
                          }),
                          option: (base, state) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: state.isSelected ? "#FFF" : "#1E1E1E",
                            backgroundColor: state.isSelected
                              ? "#3b82f6"
                              : state.isFocused
                              ? "#F3F4F6"
                              : "#FFF",
                            padding: "8px 14px",
                            cursor: "pointer",
                          }),
                        }}
                      />
                      {subTaskFormik.touched.assignee &&
                        subTaskFormik.errors.assignee && (
                          <FeildError>
                            {subTaskFormik.errors.assignee}
                          </FeildError>
                        )}
                    </FeildWraper>

                    {/* Priority */}
                    <FeildWraper>
                      <FormLabel required>Priority</FormLabel>
                      <Select
                        name="priority"
                        className="text-sm"
                        classNamePrefix="react-select"
                        options={priorityOptions}
                        components={{
                          IndicatorSeparator: () => null,
                          LoadingIndicator: () => null,
                        }}
                        value={priorityOptions?.find(
                          (option) =>
                            option.value === subTaskFormik.values.priority
                        )}
                        onChange={(selectedOption) => {
                          subTaskFormik.setFieldValue(
                            "priority",
                            selectedOption?.value || ""
                          );
                        }}
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                        placeholder="Search or select..."
                        isClearable
                        menuPlacement="auto"
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: "35px",
                            height: "auto",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            backgroundColor: state.isDisabled
                              ? "#f0f0f0"
                              : "#FFF",
                            boxShadow: state.isFocused ? "none" : "none",
                            "&:hover": { borderColor: "#DFDFDF" },
                            fontSize: "13px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            padding: "0 14px",
                            cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: "auto",
                            padding: "0 0px 0",
                          }),
                          input: (base) => ({
                            ...base,
                            margin: 0,
                            padding: 0,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            height: "auto",
                          }),
                          singleValue: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                          }),
                          placeholder: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#717680",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 99999,
                          }),
                          menu: (base) => ({
                            ...base,
                            marginTop: "2px",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          }),
                          option: (base, state) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: state.isSelected ? "#FFF" : "#1E1E1E",
                            backgroundColor: state.isSelected
                              ? "#3b82f6"
                              : state.isFocused
                              ? "#F3F4F6"
                              : "#FFF",
                            padding: "8px 14px",
                            cursor: "pointer",
                          }),
                          indicatorContainer: (base) => ({
                            ...base,
                            padding: 0,
                          }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            padding: 0,
                          }),
                        }}
                      />
                      {subTaskFormik.touched.priority &&
                        subTaskFormik.errors.priority && (
                          <FeildError>
                            {subTaskFormik.errors.priority}
                          </FeildError>
                        )}
                    </FeildWraper>

                    {/* Status */}
                    <FeildWraper>
                      <FormLabel required>Status</FormLabel>
                      <Select
                        name="sub_task_status"
                        className="text-sm"
                        classNamePrefix="react-select"
                        options={statusOptions}
                        components={{
                          IndicatorSeparator: () => null,
                          LoadingIndicator: () => null,
                        }}
                        value={statusOptions?.find(
                          (option) =>
                            option.value ===
                            subTaskFormik.values.sub_task_status
                        )}
                        onChange={(selectedOption) => {
                          subTaskFormik.setFieldValue(
                            "sub_task_status",
                            selectedOption?.value || ""
                          );
                        }}
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                        placeholder="Search or select Status..."
                        isClearable
                        menuPlacement="auto"
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: "35px",
                            height: "auto",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            backgroundColor: state.isDisabled
                              ? "#f0f0f0"
                              : "#FFF",
                            boxShadow: state.isFocused ? "none" : "none",
                            "&:hover": { borderColor: "#DFDFDF" },
                            fontSize: "13px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            padding: "0 14px",
                            cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: "auto",
                            padding: "0 0px 0",
                          }),
                          input: (base) => ({
                            ...base,
                            margin: 0,
                            padding: 0,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            height: "auto",
                          }),
                          singleValue: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                          }),
                          placeholder: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#717680",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 99999,
                          }),
                          menu: (base) => ({
                            ...base,
                            marginTop: "2px",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          }),
                          option: (base, state) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: state.isSelected ? "#FFF" : "#1E1E1E",
                            backgroundColor: state.isSelected
                              ? "#3b82f6"
                              : state.isFocused
                              ? "#F3F4F6"
                              : "#FFF",
                            padding: "8px 14px",
                            cursor: "pointer",
                          }),
                          indicatorContainer: (base) => ({
                            ...base,
                            padding: 0,
                          }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            padding: 0,
                          }),
                        }}
                      />
                      {subTaskFormik.touched.sub_task_status &&
                        subTaskFormik.errors.sub_task_status && (
                          <FeildError>
                            {subTaskFormik.errors.sub_task_status}
                          </FeildError>
                        )}
                    </FeildWraper>

                    {/* Deadline */}

                    <FeildWraper>
                      <FormLabel required>Deadline</FormLabel>
                      <input
                        type="date"
                        name="deadline"
                        value={subTaskFormik.values.deadline}
                        onChange={subTaskFormik.handleChange}
                      />
                      {subTaskFormik.touched.deadline &&
                        subTaskFormik.errors.deadline && (
                          <FeildError>
                            {subTaskFormik.errors.deadline}
                          </FeildError>
                        )}
                    </FeildWraper>

                    {/* Description */}
                    <FeildWraper width="100%">
                      <FormLabel>Description</FormLabel>
                      <textarea
                        name="sub_task_description"
                        value={subTaskFormik.values.sub_task_description}
                        onChange={subTaskFormik.handleChange}
                        rows={6}
                        placeholder="Write  description here..."
                      />
                    </FeildWraper>

                    <FeildWraper width="100%">
                      {/* Upload Box */}
                      <div
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                        onDragOver={handleSubTaskDragOver}
                        onDragLeave={handleSubTaskDragLeave}
                        onDrop={handleSubTaskDrop}
                        className={`border-2 border-dashed rounded-xl p-6 flex flex-col items-center justify-center text-center transition cursor-pointer ${
                          isDraggingSubTask
                            ? "border-black bg-gray-100"
                            : "border-gray-300 bg-gray-50 hover:bg-gray-100"
                        }`}
                      >
                        <CloudUpload className="w-10 h-10 text-black mb-3" />
                        <p className="text-gray-700 text-sm mb-2">
                          Drag & drop files here or click to select
                        </p>

                        <input
                          type="file"
                          multiple
                          onChange={handleSubTaskFileChange}
                          className="hidden"
                          id="fileInput"
                        />

                        {/* Pending uploads */}
                        {pendingUploadsSubTask?.length > 0 && (
                          <div className="mt-4 w-full max-w-sm">
                            <div className="text-xs text-gray-700 mb-2 font-semibold">
                              Pending uploads
                            </div>
                            <ul className="text-xs text-gray-700 text-left space-y-2">
                              {pendingUploadsSubTask?.map((p) => (
                                <li
                                  key={p.id}
                                  className="flex items-center justify-between bg-gray-100 px-3 py-2 rounded-md"
                                >
                                  <span className="truncate max-w-[150px]">
                                    {p.file_name}
                                  </span>
                                  <button
                                    type="button"
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      await removePendingUploadSubTask(p.id);
                                    }}
                                    className="text-gray-500 hover:text-red-600 transition"
                                    title="Remove pending upload"
                                  >
                                    <X className="w-4 h-4" />
                                  </button>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </FeildWraper>
                  </FormArea>
                </div>
              </form>
            </div>

            <div className={Style.modal_foot}>
              {(isTaskReady || navIndex === 1) && (
                <button
                  type="button"
                  disabled={
                    navIndex === 1 &&
                    editSubTaskIndex !== null &&
                    !isSubTaskReady
                  }
                  onClick={() => {
                    console.log("subTasks", isSubTaskReady);
                    if (navIndex === 0 && isTaskReady) {
                      // Task tab → Go to subtask tab
                      setNavIndex(1);
                    } else if (navIndex === 1 && !isSubTaskReady) {
                      setNavIndex(0);
                    } else if (navIndex === 1 && isSubTaskReady) {
                      // Subtask tab + ready → submit & go back
                      subTaskFormik.handleSubmit();
                      setNavIndex(0);
                    }
                  }}
                  className={`${Style.dcmb__cancel} flex items-center gap-2`}
                >
                  {navIndex === 0 && isTaskReady && (
                    <>
                      Go to Sub Task <ArrowRight size={16} />
                    </>
                  )}
                  {navIndex === 1 && isSubTaskReady && (
                    <>
                      {editSubTaskIndex !== null ? "Edit" : "Submit"} Sub Task{" "}
                      <Check size={16} />
                    </>
                  )}
                  {navIndex === 1 && !isSubTaskReady && (
                    <>
                      {editSubTaskIndex !== null ? (
                        "Fill Required Fields"
                      ) : (
                        <span className="flex gap-1 items-center">
                          Go to Task <ArrowLeft size={16} />
                        </span>
                      )}
                    </>
                  )}
                </button>
              )}
            </div>
          </LeftSidePopupLayout>
        )}

        <div className={Style.modal_foot}>
          {!taskData?.task_id
            ? (isTaskReady || navIndex === 1) && (
                <button
                  type="button"
                  disabled={
                    navIndex === 1 &&
                    editSubTaskIndex !== null &&
                    !isSubTaskReady
                  }
                  onClick={() => {
                    if (navIndex === 0 && isTaskReady) {
                      taskFormik.handleSubmit();
                      // Task tab → Go to subtask tab
                      setNavIndex(1);
                    } else if (navIndex === 1 && !isSubTaskReady) {
                      // Subtask tab but not ready → Go back to task tab
                      setNavIndex(0);
                    } else if (navIndex === 1 && isSubTaskReady) {
                      // Subtask tab + ready → submit & go back
                      subTaskFormik.handleSubmit();
                      setNavIndex(0);
                    }
                  }}
                  className={`${Style.dcmb__cancel} flex items-center gap-2`}
                >
                  {navIndex === 0 && isTaskReady && (
                    <>
                      Go to Sub Task <ArrowRight size={16} />
                    </>
                  )}
                  {navIndex === 1 && isSubTaskReady && (
                    <>
                      {editSubTaskIndex !== null ? "Edit" : "Submit"} Sub Task{" "}
                      <Check size={16} />
                    </>
                  )}
                  {navIndex === 1 && !isSubTaskReady && (
                    <>
                      {editSubTaskIndex !== null ? (
                        "Fill Required Fields"
                      ) : (
                        <span className="flex gap-1 items-center">
                          Go to Task <ArrowLeft size={16} />
                        </span>
                      )}
                    </>
                  )}
                </button>
              )
            : null}

          <button
            type="submit"
            className={Style.dcmb__submit}
            onClick={() => {
              if (navIndex === 0 && isTaskReady && subTasks?.length === 0) {
                taskFormik.handleSubmit();
                setisDirect(true);
              } else {
                handleApply();
              }
            }}
          >
            {taskData?.task_id ? "Update" : "Add"} Task
          </button>
        </div>
      </LeftSidePopupLayout>

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddTask;
